module.exports = __webpack_public_path__ + "static/img/20045B_1_2_C_20210306_fit.ec91b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_1_2_C_20210306_fit.png
// module id = VxhO
// module chunks = 0